"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWeeklyScheduleModel = void 0;
const react_1 = require("react");
const models_1 = require("../models");
require("../types");
const WeeklyScheduleHarmonizationManager_1 = require("../WeeklyScheduleHarmonizationManager");
const useWeeklyScheduleModel = (dailyScheduleModelValue, retentionFieldsSettings, isFirstRowEnabled, isSecondRowEnabled, isThirdRowEnabled, isFirstRowFieldTypeVisible, isSecondRowFieldTypeVisible, isThirdRowFieldTypeVisible, initialValue) => {
    const defaultWeeklyScheduleInitialValue = initialValue ||
        WeeklyScheduleHarmonizationManager_1.WeeklyScheduleHarmonizationManager.getMainModelInitialValue(isFirstRowEnabled, isSecondRowEnabled, isThirdRowEnabled, isFirstRowFieldTypeVisible, isSecondRowFieldTypeVisible, isThirdRowFieldTypeVisible, retentionFieldsSettings, dailyScheduleModelValue);
    const [model] = react_1.useState(() => {
        return new models_1.WeeklyScheduleModel(defaultWeeklyScheduleInitialValue);
    });
    return model;
};
exports.useWeeklyScheduleModel = useWeeklyScheduleModel;
//# sourceMappingURL=useWeeklyScheduleModel.js.map